/* eslint-disable */
import React from "react";
import "./PayTablePopUpV2.scss";
import { useHistory } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import { withTranslation, useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { get_lang } from "../../../../global-functions/apiGlobal";
import noImg from "../../assets/images/no-image.svg";

const IconArrow = () => (
  <svg
    className="ptv2-actionArrow"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M9 18l6-6-6-6"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconMenu = () => (
  <span className="ptv2-menuIcon" aria-hidden="true">
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </svg>
  </span>
);

const IconCard = () => (
  <svg
    className="ptv2-payIconSvg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="6" width="20" height="13" rx="2" />
    <line x1="2" y1="11" x2="22" y2="11" />
  </svg>
);

const IconApplePay = () => (
  <svg
    className="ptv2-payIconSvg"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

const IconVerified = () => (
  <span
    className="ptv2-verifiedBadge"
    role="img"
    aria-label="Verified by Enabill"
    title="Verified by Enabill"
  >
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12.5l4.5 4.5L19 7"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

function PayTablePopUpV2({ table }) {
  const history = useHistory();
  const appDispatch = useDispatch();
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const isRtl = appState.langValue === "ar";

  const businessName = get_lang(
    appState.storeInfo?.businessName,
    appState.langValue
  );
  const coverUrl =
    appState.storeInfo?.cover != null ? appState.storeInfo.cover : null;
  const logoUrl = appState.storeInfo?.logo || null;
  const hasCover = Boolean(coverUrl);
  const avatarLetter = (businessName || "S").trim().charAt(0).toUpperCase();
  const showMenu =
    appState?.storeInfo?.branch?.pay_table_menu &&
    !appState?.storeInfo?.justForPayTable;

  const handleClickPay = () => {
    history.push(`/checkout${appState.orderQrCode}`);
    appDispatch({
      type: "setPayTablePopUp",
      payTablePopUp: false,
    });
  };

  const handleClickOrder = () => {
    if (appState.storeInfo?.iframeUrl != null) {
      history.push("/external");
    } else {
      appDispatch({
        type: "setPayTablePopUp",
        payTablePopUp: false,
      });
      appDispatch({
        type: "setQrOptionStatus",
        qrOptionStatus: false,
      });
    }
  };

  const handleLangToggle = () => {
    appDispatch({
      type: "LangChange",
      langValue: isRtl ? "en" : "ar",
    });
  };

  const renderPaymentIcon = (method) => {
    if (method === "knet") {
      return (
        <span key={method} className="ptv2-payIcon ptv2-payIcon--knet">
          <img
            src="/images/Knet.png"
            alt=""
            width="56"
            height="38"
            decoding="async"
          />
        </span>
      );
    }
    if (method === "card") {
      return (
        <span key={method} className="ptv2-payIcon ptv2-payIcon--card">
          <IconCard />
        </span>
      );
    }
    if (method === "apple_pay") {
      return (
        <span key={method} className="ptv2-payIcon ptv2-payIcon--apple">
          <IconApplePay />
        </span>
      );
    }
    return null;
  };

  if (!appState.payTablePopUp) {
    return null;
  }

  return (
    <>
      <Backdrop
        className="ptv2-backdrop"
        open={appState.payTablePopUp}
        sx={{ zIndex: 9999 }}
      />

      <main
        className={`ptv2-page${isRtl ? " ptv2-page--rtl" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={t("checkOut.Pay-the-Bill")}
      >
        <section
          className={`ptv2-hero${hasCover ? " ptv2-hero--hasImg" : ""}`}
        >
          {hasCover ? (
            <img
              className="ptv2-heroImg"
              src={coverUrl}
              alt=""
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : null}
          <span className="ptv2-heroLogo">{businessName}</span>

          <button
            type="button"
            className="ptv2-langBtn"
            aria-label="Change language"
            onClick={handleLangToggle}
          >
            {isRtl ? "EN" : "عربي"}
          </button>
        </section>

        <section className="ptv2-card">
          <div className="ptv2-avatarRow">
            <div className="ptv2-avatar" aria-hidden="true">
              {logoUrl ? (
                <img src={logoUrl} alt="" onError={(e) => { e.currentTarget.src = noImg; }} />
              ) : (
                avatarLetter
              )}
            </div>

            <div className="ptv2-nameWrap">
              <h1 className="ptv2-restaurantName">
                <span>{businessName}</span>
                <IconVerified />
              </h1>
              {table ? (
                <p className="ptv2-tableNo">
                  {t("Forms.tableNo")}: {table}
                </p>
              ) : null}
            </div>
          </div>

          <div className="ptv2-actions">
            <button
              type="button"
              className="ptv2-actionBtn ptv2-actionBtn--primary"
              onClick={handleClickPay}
            >
              <span className="ptv2-actionBtnText">
                {t("checkOut.Pay-the-Bill")}
              </span>
              <span className="ptv2-payIconStack" aria-hidden="true">
                {(appState.acceptedPayments || []).map(renderPaymentIcon)}
              </span>
              <IconArrow />
            </button>

            {showMenu ? (
              <button
                type="button"
                className="ptv2-actionBtn ptv2-actionBtn--secondary"
                onClick={handleClickOrder}
              >
                <span className="ptv2-actionBtnText">
                  {t("checkOut.view-menu")}
                </span>
                <IconMenu />
                <IconArrow />
              </button>
            ) : null}
          </div>
        </section>

        <footer className="ptv2-footer">
          <span className="ptv2-footerInline">
            <span>{t("checkOut.pay-securely-with")}</span>
            <img
              src="/images/pat-enabill.svg"
              className="ptv2-footerLogo"
              alt="Enabill"
            />
          </span>
        </footer>
      </main>
    </>
  );
}

export default withTranslation()(PayTablePopUpV2);
